<template>
    <o-form-group
        :form-state="formState"
        :message="errorMessages"
        :type="{ 'is-danger': hasError }"
    >
        <b-form-checkbox
            :class="input_class"
            :disabled="_is_readonly"
            v-bind="$attrs"
            v-bind:checked="value"
            v-on="inputListeners"
        >
            <span v-if="!nolabel">{{ label }}</span>
        </b-form-checkbox>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";

export default {
    name: "OCheckbox",
    components: { OFormGroup },
    mixins: [FormComponentMixin],
    methods: {
        on_change(event) {
            if (event == null) if (this.value != false) event = false; // convert Null to False for checkboxes

            console.log("event change");
            this.dirty = true;
            if (this.validator) {
                this.validator.$touch();
            }
            if (this.formState) this.formState.dirty = true;

            this.changed = true;
            this.$emit("reset");
            this.$emit("input", event); // Emit input so v-model props works!
        },
    },
};
</script>

<style scoped></style>
